import axios from "axios";
import { BASE_URL } from "../../utils/urls";

export const fetchClassesFees = async (token) => {
  const res = await axios.get(`${BASE_URL}/structure-fees`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const isFeePaid = async (token) => {
  const res = await axios.get(`${BASE_URL}/student/is-student-paid`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const fetchAllSubjects = async (token) => {
  const res = await axios.get(`${BASE_URL}/student/check-student-has-subject`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

/**
 * @param {number} classId
 * @returns {*}
 */

export default fetchClassesFees;
